import React from 'react';

const ChartSkeleton = () => {
  return (
    <div className="relative w-full" style={{ paddingTop: '50%' }}>
      <div className="absolute top-0 left-0 right-0 bottom-0 bg-gray-200 animate-pulse rounded-lg">
        <div className="text-center p-4">

        </div>
      </div>
    </div>
  )
}

export default ChartSkeleton;
